// Shared i18next instance for both the marketing site and the dashboard.
//
// Landing pages get their language from the URL path (/es/pricing) so each
// locale is a distinct, crawlable URL. The dashboard (phase 6) will call
// i18n.changeLanguage() explicitly from the user's saved setting, which
// overrides detection. English is the default and carries NO path prefix.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LNGS = ['en', 'es', 'fr', 'de']; // add more here as JSON lands
export const DEFAULT_LNG = 'en';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LNGS,
    fallbackLng: DEFAULT_LNG,
    ns: ['landing'], // 'dashboard' namespace + JSON arrive in phase 6
    defaultNS: 'landing',
    load: 'languageOnly', // 'es-MX' → 'es'
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    detection: {
      // Path wins (/es/…), then a saved cookie, then the browser language.
      // An unsupported first segment (e.g. "pricing" on the bare English URL)
      // isn't in supportedLngs, so i18next falls back to DEFAULT_LNG.
      order: ['path', 'cookie', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['cookie'],
    },
    interpolation: { escapeValue: false }, // React already escapes
    react: { useSuspense: true },
  });

export default i18n;
